import React from 'react';
import styles from './styles.module.scss';

export const StickyFooter: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div className={styles.stickyFooter}>{children}</div>
);
